import { render, staticRenderFns } from "./EnterpriseSectorsTabComponent.vue?vue&type=template&id=4bb51c85&scoped=true"
import script from "./EnterpriseSectorsTabComponent.js?vue&type=script&lang=js&external"
export * from "./EnterpriseSectorsTabComponent.js?vue&type=script&lang=js&external"
import style0 from "./EnterpriseSectorsTabComponent.vue?vue&type=style&index=0&id=4bb51c85&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb51c85",
  null
  
)

export default component.exports